import de from './de';
import nl from './nl';
import en from './en';

export default {
  nl: nl,
  de: de,
  en: en,
  at: de,
  be: nl,
};



// WEBPACK FOOTER //
// ./app/languages/index.js